"use client"

import Image from "next/image"
import { Button } from "@heroui/button"
import { signIn } from "next-auth/react"

import googleIcon from "@/assets/google-icon.svg"

type AuthButtonProps = {
  redirectTo?: string
  loading?: boolean
  setLoading?: (value: boolean) => void
}

export const NewAuthButton = ({
  redirectTo,
  loading,
  setLoading,
}: AuthButtonProps) => {
  const handleClick = async () => {
    try {
      setLoading?.(true)
      await signIn("google", {
        callbackUrl: redirectTo || window.location.href,
      })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Button
      variant="bordered"
      size="sm"
      type="button"
      className="h-[40px] w-full rounded-[39px] border-none bg-[#F2F3F5] text-black"
      onPress={handleClick}
      isLoading={loading}
    >
      {!loading && (
        <Image
          src={googleIcon}
          alt="google-icon"
          width={18}
          height={18}
          unoptimized
          priority
        />
      )}
      <span>{loading ? "Signing in..." : "Sign in with Google"}</span>
    </Button>
  )
}
